import type { ReactNode } from 'react';

export const symbol_sync_arrow_down: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M128-181q-13 0-21.5-8.5T98-211q0-13 8.5-21.5T128-241h45q-61-42-95.5-106.5T43-486q0-94 52.5-168.5T233-761q12-5 23 1.5t14 18.5q3 12-3 22.5T249-703q-66 26-106 85t-40 132q0 63 30.5 117.5T218-283v-48q0-13 8.5-21.5T248-361q13 0 21.5 8.5T278-331v120q0 13-8.5 21.5T248-181H128Zm308-25q-11 4-19.5-3.5T405-228q-3-11 1-22t15-15q69-26 110.5-86T573-486q0-63-31-116t-84-85v53q0 13-8.5 21.5T428-604q-13 0-21.5-8.5T398-634v-120q0-13 8.5-21.5T428-784h120q13 0 21.5 8.5T578-754q0 13-8.5 21.5T548-724h-37q57 43 89.5 105T633-486q0 96-54.5 172.5T436-206Zm334 25-87-88q-9-9-9-21t9-21q9-9 21-9t21 9l36 36v-495q0-13 8.5-21.5T791-800q13 0 21.5 8.5T821-770v496l37-37q9-9 21-9t21 9q9 9 9 21t-9 21l-87 88q-9 9-21.5 9t-21.5-9Z"
		/>
	</svg>
);
